// extracted by mini-css-extract-plugin
export default {"join-request":"GcmRh"};